<template>
        <div v-if="developerMode" class="developer-mode-indicator">
                Developer Mode
        </div>
</template>

<script>
export default {
        data() {
                return {
                        developerMode: process.env.NODE_ENV !== 'production' // Check if in development mode
                };
        }
};
</script>
<style>
.developer-mode-indicator {
        position: fixed;
        bottom: 0;
        right: 0;
        /*background-color: red;*/
        background: linear-gradient(45deg, red, pink);
        color: white;
        padding: 3px;
        z-index: 9999;
        border-top-left-radius: 10px;
}
</style>